export default __webpack_public_path__ + "static/media/menu-01-address-book-b.50028267.svg";